import React from "react";
import "./App.css";
import "./assests/css/bootstrap.min.css";
import "./assests/fonts/themify/style.min.css";
import "./assests/fonts/flag-icon-css/css/flag-icon.min.css";
import "./assests/vendors/animate/animate.min.css";
import "./assests/vendors/flipclock/flipclock.css";
import "./assests/vendors/swiper/css/swiper.min.css";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage.tsx";
import AboutEsca from "./pages/AboutEsca";
import RoadMap from "./pages/RoadMap";
import CountDown from "./pages/CountDown";
import Footer from "./pages/Footer";
import EscaToken from "./pages/EscaToken";

function App() {
  return (
    <div className="App">
      <Layout>
        <LandingPage />
        <AboutEsca />
        <RoadMap />
        <EscaToken />
        <Footer />
      </Layout>

      <nav className="d-none vertical-social">
        <ul>
          <li>
            <a href="#">
              <i className="fa fa-telegram" aria-hidden="true" />
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-medium" aria-hidden="true" />
            </a>
          </li>
          <li>
            <a href="#">
              {"{"}" "{"}"}
              <i className="fa fa-twitter" aria-hidden="true" />
            </a>
          </li>
          <li>
            <a href="#">
              <i className="fa fa-github" aria-hidden="true" />
            </a>
          </li>
        </ul>
      </nav>
      <header className="d-none page-header">
        <nav className="main-menu static-top navbar-dark navbar navbar-expand-lg fixed-top mb-1">
          <div className="container">
            <a
              className="navbar-brand animated"
              data-animation="fadeInDown"
              data-animation-delay="1s"
              href="index.html"
            >
              <img
                src="theme-assets/images/logo.png"
                className="navbar-brand-logo"
                alt="Crypto Logo"
              />
              <img
                src="theme-assets/images/logo-dark.png"
                className="navbar-brand-logo-dark d-none"
                alt="Crypto Logo"
              />
              <span className="brand-text">
                <span className="font-weight-bold">Crypto</span> ICO
              </span>
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse">
              <div id="navigation" className="navbar-nav ml-auto">
                <ul className="navbar-nav mt-1">
                  <li
                    className="nav-item animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.1s"
                  >
                    <a className="nav-link" href="index.html#about">
                      What is ICO
                    </a>
                  </li>
                  <li
                    className="nav-item animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.2s"
                  >
                    <a className="nav-link" href="index.html#problem-solution">
                      Solutions
                    </a>
                  </li>
                  <li
                    className="nav-item animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.3s"
                  >
                    <a className="nav-link" href="index.html#token-sale">
                      Token Sale
                    </a>
                  </li>
                  <li
                    className="nav-item animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.4s"
                  >
                    <a className="nav-link" href="index.html#whitepaper">
                      Whitepaper
                    </a>
                  </li>
                  <li
                    className="nav-item animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.5s"
                  >
                    <a className="nav-link" href="index.html#roadmap">
                      Roadmap
                    </a>
                  </li>
                  <li
                    className="dropdown show mr-2 px-2 animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.6s"
                  >
                    <a
                      className="dropdown-toggle white"
                      href="#"
                      role="button"
                      id="more"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      More
                    </a>
                    <div className="dropdown-menu" aria-labelledby="more">
                      <a className="dropdown-item" href="index.html#team">
                        Team
                      </a>
                      <a className="dropdown-item" href="index.html#faq">
                        FAQ
                      </a>
                      <a className="dropdown-item" href="index.html#news">
                        News
                      </a>
                      <a className="dropdown-item" href="index.html#contact">
                        Contact
                      </a>
                      <a className="dropdown-item" href="template-404.html">
                        404
                      </a>
                      <a
                        className="dropdown-item"
                        href="template-inner-page-with-sidebar.html"
                      >
                        Sample Page
                      </a>
                    </div>
                  </li>
                  <li
                    className="dropdown show mr-4 animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.7s"
                  >
                    <a
                      className="dropdown-toggle"
                      href="#"
                      role="button"
                      id="language"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span className="flag-icon flag-icon-us" /> EN
                    </a>
                    <div className="dropdown-menu" aria-labelledby="language">
                      <a className="dropdown-item" href="#">
                        <span className="flag-icon flag-icon-de" /> DE
                      </a>
                      <a className="dropdown-item" href="#">
                        <span className="flag-icon flag-icon-es" /> SP
                      </a>
                      <a className="dropdown-item" href="#">
                        <span className="flag-icon flag-icon-mq" /> MQ
                      </a>
                    </div>
                  </li>
                </ul>
                <span id="slide-line" />
                <form className="form-inline mt-2 mt-md-0">
                  <a
                    className="btn btn-sm btn-light btn-glow btn-round btn-sign-in my-2 my-sm-0 animated"
                    data-animation="fadeInDown"
                    data-animation-delay="1.8s"
                    href="https://pixinvent.com/demo/crypto-ico-admin/html/ltr/vertical-menu/account-login.html"
                    target="_blank"
                  >
                    Sign in
                  </a>
                </form>
              </div>
            </div>
          </div>
        </nav>
      </header>
      <div className="d-none content-wrapper">
        <div className="content-body">
          <main>
            <section className="head-area" id="head-area" data-midnight="white">
              <div className="bg-shape">
                <div className="bg-ripple-animation d-none d-md-block">
                  <div className="intro-video-bg-ripples">
                    <div className="ripples" />
                  </div>
                </div>
              </div>
              <div className="head-content container-fluid d-flex align-items-center">
                <div className="container">
                  <div className="banner-wrapper">
                    <div className="row align-items-center">
                      <div className="col-lg-6 col-md-12">
                        <div className="banner-content">
                          <h1
                            className="best-template animated"
                            data-animation="fadeInUpShorter"
                            data-animation-delay="1.5s"
                          >
                            Crypto ICO is modern, clean and{"{"}" "{"}"}
                            <br className="d-none d-xl-block" />
                            gradient ui ico most trending{"{"}" "{"}"}
                            <br className="d-none d-xl-block" />
                            template of 2019
                          </h1>
                          <h3
                            className="d-block animated"
                            data-animation="fadeInUpShorter"
                            data-animation-delay="1.6s"
                          >
                            First decentralized marketing platform that allows
                            {"{"}" "{"}"}
                            <br className="d-none d-xl-block" />
                            merchants and affiliates.
                          </h3>
                          <div className="mt-4">
                            <a
                              href="#token-sale"
                              className="btn btn-lg btn-round btn-light btn-glow animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="1.7s"
                            >
                              Purchase Token
                            </a>
                            <a
                              href="#whitepaper"
                              className="btn btn-lg btn-round btn-light btn-glow ml-4 animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="1.8s"
                            >
                              Whitepaper
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 move-first">
                        <div
                          className="crypto-video animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="1.7s"
                        >
                          <img
                            src="theme-assets/images/video-banner.png"
                            className="video-img img-fluid"
                            alt="CICO"
                          />
                          <div className="play-video text-center">
                            <a
                              href="#"
                              className="play rounded-circle btn-gradient-orange video-btn"
                              data-toggle="modal"
                              data-src="https://www.youtube.com/embed/UXAJu3zS4bU"
                              data-target="#ico-modal"
                            >
                              <i className="ti-control-play" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="exchange-listing" id="exchange-listing">
              <div className="container-fluid bg-color">
                <div className="container">
                  <div className="row listing list-unstyled">
                    <div
                      className="col d-none d-lg-block text-center animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      <img
                        src="theme-assets/images/icon-arrow.png"
                        alt="icon-arrow"
                      />
                      <p className="grey-accent2 mt-1">
                        Exchange listing
                        <br />
                        to be announced
                      </p>
                    </div>
                    <div
                      className="col animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <h2>4.3/5</h2>
                      <img
                        src="theme-assets/images/ico-track.png"
                        alt="ico-track"
                      />
                    </div>
                    <div
                      className="col animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      <h2>4.8/5</h2>
                      <img
                        src="theme-assets/images/ico-bench.png"
                        alt="ico-bench"
                      />
                    </div>
                    <div
                      className="col animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.5s"
                    >
                      <h2>3.9/5</h2>
                      <img
                        src="theme-assets/images/ico-ranker.png"
                        alt="ico-ranker"
                      />
                    </div>
                    <div
                      className="col animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.6s"
                    >
                      <h2>4.1/5</h2>
                      <img
                        src="theme-assets/images/ico-bazaar.png"
                        alt="ico-bazaar"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              id="problem-solution"
              className="problem-solution section-pro section-padding bg-color"
            >
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      Solutions
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      Problems &amp; <strong>Solutions</strong>
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      More than $40 million in assets were placed under
                      restraint pending forfeiture, and more than 30
                      <br />
                      Liberty Reserve exchanger domain names were seized.
                    </p>
                  </div>
                  <div className="problems">
                    <div className="row">
                      <div className="col-md-12 col-lg-6">
                        <div className="heading mb-4">
                          <h4
                            className="title animated"
                            data-animation="fadeInUpShorter"
                            data-animation-delay="0.2s"
                          >
                            Problems
                          </h4>
                          <div
                            className="separator animated"
                            data-animation="fadeInUpShorter"
                            data-animation-delay="0.3s"
                          >
                            <span className="large" />
                            <span className="medium" />
                            <span className="small" />
                          </div>
                        </div>
                        <p
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.5s"
                        >
                          Different pieces of the new Internet are born as
                          building blocks, but there’s no way for them to work
                          together.
                        </p>
                        <p
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.7s"
                        >
                          Even interoperating new technologies with old
                          centralised resources can prove useful in making the
                          paradigm shift from Web 2 to Web 3 happen. Now we own
                          our data, we can prove that we own what we have and
                          have created it on different platforms, but how do we
                          put it together into a whole new cohesive framework.
                        </p>
                      </div>
                      <div className="col-md-12 col-lg-6 text-center">
                        <img
                          src="theme-assets/images/problems-graphic.png"
                          className="problems-img animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.6s"
                          alt="problems-graphic"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="solutions mt-5">
                    <div className="row">
                      <div className="col-md-12 col-lg-6 text-center">
                        <img
                          src="theme-assets/images/solutions-graphic.png"
                          className="solutions-img animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.6s"
                          alt="problems-graphic"
                        />
                      </div>
                      <div className="col-md-12 col-lg-6 move-first">
                        <div className="heading mb-4">
                          <h4
                            className="title animated"
                            data-animation="fadeInUpShorter"
                            data-animation-delay="0.2s"
                          >
                            Solutions
                          </h4>
                          <div
                            className="separator animated"
                            data-animation="fadeInUpShorter"
                            data-animation-delay="0.3s"
                          >
                            <span className="large" />
                            <span className="medium" />
                            <span className="small" />
                          </div>
                        </div>
                        <p
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.5"
                        >
                          Decentralized cryptocurrency is produced by the entire
                          cryptocurrency system collectively, at a rate which is
                          defined when the system is created and which is
                          publicly known.
                        </p>
                        <p
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.7s"
                        >
                          In centralized banking and economic systems such as
                          the Federal Reserve System, corporate boards or
                          governments control the supply of currency by printing
                          units of fiat money or demanding additions to digital
                          banking ledgers.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="token-sale" className="token-sale section-padding">
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      Token
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <strong>Pre-Tokens Sale</strong> &amp; Values
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      The first token sale (also known as an ICO) was held by
                      Mastercoin in
                      <br />
                      July 2013. Ethereum raised money with a token sale in
                      2014.
                    </p>
                  </div>
                  <div className="row align-items-center">
                    <div
                      className="col-md-12 col-lg-6 col-xl-5 animated"
                      data-animation="fadeInLeftShorter"
                      data-animation-delay="0.6s"
                    >
                      <h5>ICO will start in</h5>
                      <div className="token-details text-center">
                        <div className="clock-counter mb-4">
                          <div className="clock ml-0 mt-5 justify-content-center d-flex" />
                          <div className="message" />
                        </div>
                        <div className="loading-bar mb-2 position-relative">
                          <div className="progres-area pb-5">
                            <ul className="progress-top">
                              <li />
                              <li className="pre-sale">Pre-Sale</li>
                              <li>Soft Cap</li>
                              <li className="bonus">Bonus</li>
                              <li />
                            </ul>
                            <ul className="progress-bars">
                              <li />
                              <li>|</li>
                              <li>|</li>
                              <li>|</li>
                              <li />
                            </ul>
                            <div className="progress">
                              <div
                                className="progress-bar progress-bar-custom"
                                role="progressbar"
                                style={{ width: "65%" }}
                                aria-valuenow={100}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                            <div className="progress-bottom">
                              <div className="progress-info">
                                65% target raised
                              </div>
                              <div className="progress-info">
                                1 ETH = $1000 = 3177.38 CIC
                              </div>
                            </div>
                          </div>
                        </div>
                        <a
                          href="#"
                          className="btn btn-lg btn-glow btn-round btn-gradient-blue"
                        >
                          Purchase Token
                        </a>
                      </div>
                    </div>
                    <div
                      className="col-md-12 col-lg-6 col-xl-7 animated"
                      data-animation="fadeInRightShorter"
                      data-animation-delay="0.6s"
                    >
                      <div className="row ml-0 mt-5">
                        <p className="grey-accent2">
                          <b>
                            We have successfully reached the soft cap! Join now
                            and get a higher discount.
                            <br />
                            Get your tokens for the best price: We fixed the
                            Ether price at $800.
                          </b>
                        </p>
                        <div className="col-md-5">
                          <ul className="token-sale-info">
                            <li>
                              Public PRE-ITS starts <strong>13 March</strong>
                            </li>
                            <li>
                              Public ITS ends <strong>25 May</strong>
                            </li>
                            <li>
                              Public ITS starts <strong>25 April</strong>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-7 pr-0">
                          <ul className="token-sale-info">
                            <li>
                              Acceptable currencies{"{"}" "{"}"}
                              <strong>ETH, BTC, LTC</strong>
                            </li>
                            <li>
                              Minimal transaction amount{"{"}" "{"}"}
                              <strong>1 ETH, 1 BTC, 1 LTC</strong>
                            </li>
                            <li>
                              Number of tokens for sale{"{"}" "{"}"}
                              <strong>890,000 CIC (8%)</strong>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              id="whitepaper"
              className="whitepaper section-pro section-padding bg-color"
            >
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      Whitepaper
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <strong>Documents,</strong> Terms &amp; Conditions
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      Terms of service are rules by which one must agree to
                      abide in order to use a service.
                      <br />
                      Terms of service can also be merely a disclaimer,
                      especially regarding the use of websites.
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-5">
                      <div className="whitepaper-img">
                        <img
                          className="img-fluid animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.6s"
                          src="theme-assets/images/whitepaper.png"
                          alt="whitepaper"
                        />
                      </div>
                    </div>
                    <div className="col-sm-12 col-md-7">
                      <div className="content-area">
                        <h4
                          className="title animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.5s"
                        >
                          Whitepaper
                        </h4>
                        <p
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.6s"
                        >
                          A white paper is an authoritative report or guide that
                          informs readers concisely about a complex issue and
                          presents the issuing body's philosophy on the matter.
                          It is meant to help readers understand an issue, solve
                          a problem, or make a decision.
                        </p>
                        <p
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.7s"
                        >
                          The initial British term concerning a type of
                          government-issued document has proliferated, taking a
                          somewhat new meaning in business. In business, a white
                          paper is closer to a form of marketing presentation, a
                          tool meant to persuade customers and partners and
                          promote a product or viewpoint, White papers may be
                          considered grey literature.
                        </p>
                        <p
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.8s"
                        >
                          Since the early 1990s, the term "white paper", or
                          "whitepaper", has been applied to documents used as
                          marketing or sales tools in business.
                        </p>
                        <div className="whitepaper-languages">
                          <div className="row">
                            <div
                              className="col-6 col-md-3 text-center mt-4 animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="0.6s"
                            >
                              <a href="#" title="English">
                                <img
                                  src="theme-assets/images/flag-1.png"
                                  alt="English"
                                />
                                <div className="lang-text">
                                  <span className="icon ti-download mr-1" />
                                  <span className="language">English</span>
                                </div>
                              </a>
                            </div>
                            <div
                              className="col-6 col-md-3 text-center mt-4 animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="0.7s"
                            >
                              <a href="#" title="Japanese">
                                <img
                                  src="theme-assets/images/flag-2.png"
                                  alt="English"
                                />
                                <div className="lang-text">
                                  <span className="icon ti-download mr-1" />
                                  <span className="language">Japanese</span>
                                </div>
                              </a>
                            </div>
                            <div
                              className="col-6 col-md-3 text-center mt-4 animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="0.8s"
                            >
                              <a href="#" title="Russian">
                                <img
                                  src="theme-assets/images/flag-3.png"
                                  alt="English"
                                />
                                <div className="lang-text">
                                  <span className="icon ti-download mr-1" />
                                  <span className="language">Russian</span>
                                </div>
                              </a>
                            </div>
                            <div
                              className="col-6 col-md-3 text-center mt-4 animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="0.9s"
                            >
                              <a href="#" title="Chinese">
                                <img
                                  src="theme-assets/images/flag-4.png"
                                  alt="English"
                                />
                                <div className="lang-text">
                                  <span className="icon ti-download mr-1" />
                                  <span className="language">Chinese</span>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            
            <section
              id="token-distribution"
              className="token-distribution section-pro section-padding bg-color"
            >
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      Token Distribution
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <strong>Token</strong> Sale Stats
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      The ICO usually takes place before the project is
                      completed, and helps fund the expenses
                      <br />
                      undertaken by the founding team until launch. For some of
                      the larger projects.
                    </p>
                  </div>
                  <div className="row">
                    <div
                      className="col-md-12 col-lg-6 col-xl-6 animated"
                      data-animation="fadeInLeftShorter"
                      data-animation-delay="0.6s"
                    >
                      <div className="token-img">
                        <img
                          className="img-fluid"
                          src="theme-assets/images/chart.png"
                          alt="token-distribution"
                        />
                      </div>
                    </div>
                    <div
                      className="col-md-12 col-lg-6 col-xl-5 offset-xl-1 animated"
                      data-animation="fadeInRightShorter"
                      data-animation-delay="0.6s"
                    >
                      <div className="content-area">
                        <h4 className="title">Details</h4>
                        <p className="mt-1">
                          To calculate the number of tokens you’ll receive, you
                          can follow the following formula. Note that this
                          applies to public presale contributions only. If you
                          participated through a syndicate or private presale,
                        </p>
                        <p>
                          To calculate the number of tokens you’ll receive, you
                          can follow the following formula. Note that this
                          applies to public presale contributions only. If you
                          participated through a syndicate or private presale,
                        </p>
                        <p>
                          <span>Symbol:</span>
                          {"{"}" "{"}"}
                          <strong className="grey-accent2">CIC</strong>
                        </p>
                        <p>
                          <span>Initial Value:</span>
                          {"{"}" "{"}"}
                          <strong className="grey-accent2">
                            1 ETH = 3177.38 CIC
                          </strong>
                        </p>
                        <p>
                          <span>Type:</span>
                          {"{"}" "{"}"}
                          <strong className="grey-accent2">ERC20</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="team" className="team section-padding">
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      Team
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      Creative <strong>Team</strong>
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      A cryptocurrency (or crypto currency) is a digital asset
                      designed to work as a medium
                      <br />
                      of exchange that uses cryptography to secure its
                      transactions.
                    </p>
                  </div>
                  <div className="row team-intro justify-content-center text-center">
                    <div
                      className="col-12 col-md-4 col-lg-2  team-width animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.5s"
                    >
                      <span>18</span>
                      <p>
                        Creative and
                        <br />
                        Dedicated People
                      </p>
                    </div>
                    <div
                      className="col-12 col-md-4 col-lg-2  team-width animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.6s"
                    >
                      <span>125</span>
                      <p>Years of combined experience</p>
                    </div>
                    <div
                      className="col-12 col-md-4 col-lg-2  team-width animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.7s"
                    >
                      <span>10</span>
                      <p>Years of blockchain experience</p>
                    </div>
                  </div>
                  <div className="team-profile mt-5">
                    <div className="row mb-5">
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="0.8s"
                      >
                        <div className="d-flex team-member">
                          <div
                            className="team-img float-left mr-3"
                            data-toggle="modal"
                            data-target="#teamUser9"
                          >
                            <img
                              src="theme-assets/images/user-9.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Logan S. Perez</div>
                            <div className="role">CEO &amp; CFO</div>
                            <div className="social-profile mt-3">
                              <a href="#" title="Linkedin" className="mr-2">
                                <i className="ti-linkedin" />
                              </a>
                              <a href="#" title="Twitter" className="mr-2">
                                <i className="ti-twitter-alt" />
                              </a>
                              <a href="#" title="Github">
                                <i className="ti-github" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="0.9s"
                      >
                        <div className="d-flex team-member">
                          <div
                            className="team-img float-left mr-3"
                            data-toggle="modal"
                            data-target="#teamUser6"
                          >
                            <img
                              src="theme-assets/images/user-6.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Susan J. Newsom</div>
                            <div className="role">Graphic Designer</div>
                            <div className="social-profile mt-3">
                              <a href="#" title="Linkedin" className="mr-2">
                                <i className="ti-linkedin" />
                              </a>
                              <a href="#" title="Twitter" className="mr-2">
                                <i className="ti-twitter-alt" />
                              </a>
                              <a href="#" title="Github">
                                <i className="ti-github" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="1.0s"
                      >
                        <div className="d-flex team-member">
                          <div
                            className="team-img float-left mr-3"
                            data-toggle="modal"
                            data-target="#teamUser2"
                          >
                            <img
                              src="theme-assets/images/user-2.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Mary J. Wardle</div>
                            <div className="role">CPO</div>
                            <div className="social-profile mt-3">
                              <a href="#" title="Linkedin" className="mr-2">
                                <i className="ti-linkedin" />
                              </a>
                              <a href="#" title="Twitter" className="mr-2">
                                <i className="ti-twitter-alt" />
                              </a>
                              <a href="#" title="Github">
                                <i className="ti-github" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="1.1s"
                        data-toggle="modal"
                        data-target="#teamUser10"
                      >
                        <div className="d-flex team-member">
                          <div className="team-img float-left mr-3">
                            <img
                              src="theme-assets/images/user-10.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Nicholas M. Sharpe</div>
                            <div className="role">UI / UX Designer</div>
                            <div className="social-profile mt-3">
                              <a href="#" title="Linkedin" className="mr-2">
                                <i className="ti-linkedin" />
                              </a>
                              <a href="#" title="Twitter" className="mr-2">
                                <i className="ti-twitter-alt" />
                              </a>
                              <a href="#" title="Github">
                                <i className="ti-github" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="1.2s"
                        data-toggle="modal"
                        data-target="#teamUser4"
                      >
                        <div className="d-flex team-member">
                          <div className="team-img float-left mr-3">
                            <img
                              src="theme-assets/images/user-4.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Cecelia T. Carter</div>
                            <div className="role">CTO</div>
                            <div className="social-profile mt-3">
                              <a href="#" title="Linkedin" className="mr-2">
                                <i className="ti-linkedin" />
                              </a>
                              <a href="#" title="Twitter" className="mr-2">
                                <i className="ti-twitter-alt" />
                              </a>
                              <a href="#" title="Github">
                                <i className="ti-github" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="1.3s"
                        data-toggle="modal"
                        data-target="#teamUser13"
                      >
                        <div className="d-flex team-member">
                          <div className="team-img float-left mr-3">
                            <img
                              src="theme-assets/images/user-13.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Terry T. Robinette</div>
                            <div className="role">Developer</div>
                            <div className="social-profile mt-3">
                              <a href="#" title="Linkedin" className="mr-2">
                                <i className="ti-linkedin" />
                              </a>
                              <a href="#" title="Twitter" className="mr-2">
                                <i className="ti-twitter-alt" />
                              </a>
                              <a href="#" title="Github">
                                <i className="ti-github" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section
              id="advisor"
              className="team advisor section-pro section-padding bg-color"
            >
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      Advisors
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <strong>Advisors</strong> in the platform
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="flipInUp"
                      data-animation-delay="0.4s"
                    >
                      Digital currency is a money balance recorded
                      electronically on <br />a stored-value card or other
                      device. Another form of electronic money is network money.
                    </p>
                  </div>
                  <div className="team-profile mt-5">
                    <div className="row mb-5">
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="0.5s"
                      >
                        <div className="d-flex">
                          <div
                            className="team-img float-left mr-3"
                            data-toggle="modal"
                            data-target="#teamUser1"
                          >
                            <img
                              src="theme-assets/images/user-1.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="team-icon">
                            <i className="ti-linkedin" />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Nadia Sidko</div>
                            <div className="role">Blockchain Entrepreneur</div>
                            <div className="crypto-profile">
                              <img
                                src="theme-assets/images/company-logo-1.png"
                                alt="Team User"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="0.6s"
                      >
                        <div className="d-flex">
                          <div
                            className="team-img float-left mr-3"
                            data-toggle="modal"
                            data-target="#teamUser8"
                          >
                            <img
                              src="theme-assets/images/user-8.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="team-icon">
                            <i className="ti-linkedin" />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Pavel Volek</div>
                            <div className="role">
                              Entrepreneur and Investor
                            </div>
                            <div className="crypto-profile">
                              <img
                                src="theme-assets/images/company-logo-2.png"
                                alt="Team User"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="0.7s"
                        data-toggle="modal"
                        data-target="#teamUser3"
                      >
                        <div className="d-flex">
                          <div className="team-img float-left mr-3">
                            <img
                              src="theme-assets/images/user-3.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="team-icon">
                            <i className="ti-linkedin" />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Alyona Blakytna</div>
                            <div className="role">Fin-Tech Entrepreneur</div>
                            <div className="crypto-profile">
                              <img
                                src="theme-assets/images/company-logo-3.png"
                                alt="Team User"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="0.8s"
                        data-toggle="modal"
                        data-target="#teamUser11"
                      >
                        <div className="d-flex">
                          <div className="team-img float-left mr-3">
                            <img
                              src="theme-assets/images/user-11.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="team-icon">
                            <i className="ti-linkedin" />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Martin Solarik</div>
                            <div className="role">Fin-Tech Investor</div>
                            <div className="crypto-profile">
                              <img
                                src="theme-assets/images/company-logo-4.png"
                                alt="Team User"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="0.9s"
                        data-toggle="modal"
                        data-target="#teamUser7"
                      >
                        <div className="d-flex">
                          <div className="team-img float-left mr-3">
                            <img
                              src="theme-assets/images/user-7.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="team-icon">
                            <i className="ti-linkedin" />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Kate Fisenko</div>
                            <div className="role">Fin-Tech Investor</div>
                            <div className="crypto-profile">
                              <img
                                src="theme-assets/images/company-logo-5.png"
                                alt="Team User"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-sm-12 col-md-6 col-lg-4 mb-5 animated"
                        data-animation="jello"
                        data-animation-delay="1.0s"
                        data-toggle="modal"
                        data-target="#teamUser12"
                      >
                        <div className="d-flex">
                          <div className="team-img float-left mr-3">
                            <img
                              src="theme-assets/images/user-12.png"
                              alt="team-profile-1"
                              className="rounded-circle"
                              width={128}
                            />
                          </div>
                          <div className="team-icon">
                            <i className="ti-linkedin" />
                          </div>
                          <div className="profile align-self-center">
                            <div className="name">Michal Krajnansky</div>
                            <div className="role">Blockchain Entrepreneur</div>
                            <div className="crypto-profile">
                              <img
                                src="theme-assets/images/company-logo-1.png"
                                alt="Team User"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="faq" className="faq section-padding">
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      FAQ
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      Frequently Asked <strong>Questions</strong>
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="jello"
                      data-animation-delay="0.4s"
                    >
                      Originally the term "FAQ" referred to the Frequently Asked
                      Question itself, and the
                      <br />
                      compilation of questions and answers was known as a "FAQ
                      list" or some similar expression.
                    </p>
                  </div>
                  <div className="row">
                    <div className="col">
                      <nav>
                        <div
                          className="nav nav-pills nav-underline mb-5 animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.5s"
                          id="myTab"
                          role="tablist"
                        >
                          <a
                            href="#general"
                            className="nav-item nav-link active"
                            id="general-tab"
                            data-toggle="tab"
                            aria-controls="general"
                            aria-selected="true"
                            role="tab"
                          >
                            General
                          </a>
                          <a
                            href="#ico"
                            className="nav-item nav-link"
                            id="ico-tab"
                            data-toggle="tab"
                            aria-controls="ico"
                            aria-selected="false"
                            role="tab"
                          >
                            Pre-ICO
                          </a>
                          <a
                            href="#token"
                            className="nav-item nav-link"
                            id="token-tab"
                            data-toggle="tab"
                            aria-controls="token"
                            aria-selected="false"
                            role="tab"
                          >
                            Tokens
                          </a>
                          <a
                            href="#client"
                            className="nav-item nav-link"
                            id="client-tab"
                            data-toggle="tab"
                            aria-controls="client"
                            aria-selected="false"
                            role="tab"
                          >
                            Client
                          </a>
                          <a
                            href="#legal"
                            className="nav-item nav-link"
                            id="legal-tab"
                            data-toggle="tab"
                            aria-controls="legal"
                            aria-selected="false"
                            role="tab"
                          >
                            Legal
                          </a>
                        </div>
                      </nav>
                      <div className="tab-content" id="myTabContent">
                        <div
                          className="tab-pane fade show active"
                          id="general"
                          role="tabpanel"
                          aria-labelledby="general-tab"
                        >
                          <div
                            id="general-accordion"
                            className="collapse-icon accordion-icon-rotate"
                          >
                            <div
                              className="card animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="0.1s"
                            >
                              <div className="card-header" id="headingOne">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link"
                                    data-toggle="collapse"
                                    data-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                  >
                                    <span className="icon" />
                                    Can I make payments directly from an
                                    exchange?
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="collapseOne"
                                className="collapse show"
                                aria-labelledby="headingOne"
                                data-parent="#general-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div
                              className="card animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="0.2s"
                            >
                              <div className="card-header" id="headingTwo">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                  >
                                    <span className="icon" />
                                    When will CICO be listed on exchanges?
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="collapseTwo"
                                className="collapse"
                                aria-labelledby="headingTwo"
                                data-parent="#general-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div
                              className="card animated"
                              data-animation="fadeInUpShorter"
                              data-animation-delay="0.3s"
                            >
                              <div className="card-header" id="headingThree">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#collapseThree"
                                    aria-expanded="false"
                                    aria-controls="collapseThree"
                                  >
                                    <span className="icon" />
                                    What is the CICO Token asmart contract
                                    address?
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="collapseThree"
                                className="collapse"
                                aria-labelledby="headingThree"
                                data-parent="#general-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="ico"
                          role="tabpanel"
                          aria-labelledby="ico-tab"
                        >
                          <div
                            id="ico-accordion"
                            className="collapse-icon accordion-icon-rotate"
                          >
                            <div className="card">
                              <div className="card-header" id="icoHeadingOne">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link"
                                    data-toggle="collapse"
                                    data-target="#icoCollapseOne"
                                    aria-expanded="true"
                                    aria-controls="icoCollapseOne"
                                  >
                                    <span className="icon" />
                                    Pityful a rethoric question ran over her
                                    cheek?
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="icoCollapseOne"
                                className="collapse show"
                                aria-labelledby="icoHeadingOne"
                                data-parent="#ico-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="icoHeadingTwo">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#icoCollapseTwo"
                                    aria-expanded="false"
                                    aria-controls="icoCollapseTwo"
                                  >
                                    <span className="icon" />
                                    Which roasted parts of sentences fly into
                                    your mouth?
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="icoCollapseTwo"
                                className="collapse"
                                aria-labelledby="icoHeadingTwo"
                                data-parent="#ico-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="icoHeadingThree">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#icoCollapseThree"
                                    aria-expanded="false"
                                    aria-controls="icoCollapseThree"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #3
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="icoCollapseThree"
                                className="collapse"
                                aria-labelledby="icoHeadingThree"
                                data-parent="#ico-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="token"
                          role="tabpanel"
                          aria-labelledby="token-tab"
                        >
                          <div
                            id="token-accordion"
                            className="collapse-icon accordion-icon-rotate"
                          >
                            <div className="card">
                              <div className="card-header" id="tokenHeadingOne">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link"
                                    data-toggle="collapse"
                                    data-target="#tokenCollapseOne"
                                    aria-expanded="true"
                                    aria-controls="tokenCollapseOne"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #1
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="tokenCollapseOne"
                                className="collapse show"
                                aria-labelledby="tokenHeadingOne"
                                data-parent="#token-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="tokenHeadingTwo">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#tokenCollapseTwo"
                                    aria-expanded="false"
                                    aria-controls="tokenCollapseTwo"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #2
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="tokenCollapseTwo"
                                className="collapse"
                                aria-labelledby="tokenHeadingTwo"
                                data-parent="#token-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div
                                className="card-header"
                                id="tokenHeadingThree"
                              >
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#tokenCollapseThree"
                                    aria-expanded="false"
                                    aria-controls="tokenCollapseThree"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #3
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="tokenCollapseThree"
                                className="collapse"
                                aria-labelledby="tokenHeadingThree"
                                data-parent="#token-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="client"
                          role="tabpanel"
                          aria-labelledby="client-tab"
                        >
                          <div
                            id="client-accordion"
                            className="collapse-icon accordion-icon-rotate"
                          >
                            <div className="card">
                              <div
                                className="card-header"
                                id="clientHeadingOne"
                              >
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link"
                                    data-toggle="collapse"
                                    data-target="#clientCollapseOne"
                                    aria-expanded="true"
                                    aria-controls="clientCollapseOne"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #1
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="clientCollapseOne"
                                className="collapse show"
                                aria-labelledby="clientHeadingOne"
                                data-parent="#client-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div
                                className="card-header"
                                id="clientHeadingTwo"
                              >
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#clientCollapseTwo"
                                    aria-expanded="false"
                                    aria-controls="clientCollapseTwo"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #2
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="clientCollapseTwo"
                                className="collapse"
                                aria-labelledby="clientHeadingTwo"
                                data-parent="#client-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div
                                className="card-header"
                                id="clientHeadingThree"
                              >
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#clientCollapseThree"
                                    aria-expanded="false"
                                    aria-controls="clientCollapseThree"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #3
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="clientCollapseThree"
                                className="collapse"
                                aria-labelledby="clientHeadingThree"
                                data-parent="#client-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="legal"
                          role="tabpanel"
                          aria-labelledby="legal-tab"
                        >
                          <div
                            id="legal-accordion"
                            className="collapse-icon accordion-icon-rotate"
                          >
                            <div className="card">
                              <div className="card-header" id="legalHeadingOne">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link"
                                    data-toggle="collapse"
                                    data-target="#legalCollapseOne"
                                    aria-expanded="true"
                                    aria-controls="legalCollapseOne"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #1
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="legalCollapseOne"
                                className="collapse show"
                                aria-labelledby="legalHeadingOne"
                                data-parent="#legal-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div className="card-header" id="legalHeadingTwo">
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#legalCollapseTwo"
                                    aria-expanded="false"
                                    aria-controls="legalCollapseTwo"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #2
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="legalCollapseTwo"
                                className="collapse"
                                aria-labelledby="legalHeadingTwo"
                                data-parent="#legal-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                            <div className="card">
                              <div
                                className="card-header"
                                id="legalHeadingThree"
                              >
                                <h5 className="mb-0">
                                  <a
                                    className="btn btn-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#legalCollapseThree"
                                    aria-expanded="false"
                                    aria-controls="legalCollapseThree"
                                  >
                                    <span className="icon" />
                                    Collapsible Group Item #3
                                  </a>
                                </h5>
                              </div>
                              <div
                                id="legalCollapseThree"
                                className="collapse"
                                aria-labelledby="legalHeadingThree"
                                data-parent="#legal-accordion"
                              >
                                <div className="card-body">
                                  Anim pariatur cliche reprehenderit, enim
                                  eiusmod high life accusamus terry richardson
                                  ad squid. 3 wolf moon officia aute, non
                                  cupidatat skateboard dolor brunch. Food truck
                                  quinoa nesciunt laborum eiusmod. Brunch 3 wolf
                                  moon tempor, sunt aliqua put a bird on it
                                  squid single-origin coffee nulla assumenda
                                  shoreditch et. Nihil anim keffiyeh helvetica,
                                  craft beer labore wes anderson cred nesciunt
                                  sapiente ea proident. Ad vegan excepteur
                                  butcher vice lomo. Leggings occaecat craft
                                  beer farm-to-table, raw denim aesthetic synth
                                  nesciunt you probably haven't heard of them
                                  accusamus labore sustainable VHS.
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="news" className="news section-padding bg-color">
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      News
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      Recent <strong>News Posts</strong>
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      A blog is a discussion or informational website published
                      on the World Wide
                      <br />
                      Web consisting of discrete, often informal diary-style
                      text entries posts.
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-lg-4 mb-sm-5  mb-xs-5">
                      <div
                        className="card animated"
                        data-animation="fadeInUpShorter"
                        data-animation-delay="0.5s"
                      >
                        <img
                          className="card-img-top"
                          src="theme-assets/images/news-1.png"
                          alt="blog-image1"
                          width={370}
                          height={583}
                        />
                        <div className="card-img-overlay">
                          <div className="blog-content">
                            <h5 className="card-title mt-3">Author Name</h5>
                            <h2 className="mt-4">Cryptocurrency Mobile App</h2>
                          </div>
                        </div>
                        <div className="card-footer">
                          <a
                            href="template-blog-detail.html"
                            className="read-more btn btn-round btn-glow btn-gradient-blue"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-4 mb-sm-5  mb-xs-5">
                      <div
                        className="card animated"
                        data-animation="fadeInUpShorter"
                        data-animation-delay="0.5s"
                      >
                        <img
                          className="card-img-top"
                          src="theme-assets/images/news-2.png"
                          alt="blog-image1"
                          width={370}
                          height={583}
                        />
                        <div className="card-img-overlay">
                          <div className="blog-content">
                            <h5 className="card-title mt-3">Author Name</h5>
                            <h2 className="mt-4">Cryptocurrency Mobile App</h2>
                          </div>
                        </div>
                        <div className="card-footer">
                          <a
                            href="template-blog-detail.html"
                            className="read-more btn btn-round btn-glow btn-gradient-blue"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-4 mb-sm-5  mb-xs-5">
                      <div
                        className="card animated"
                        data-animation="fadeInUpShorter"
                        data-animation-delay="0.5s"
                      >
                        <img
                          className="card-img-top"
                          src="theme-assets/images/news-3.png"
                          alt="blog-image1"
                          width={370}
                          height={583}
                        />
                        <div className="card-img-overlay">
                          <div className="blog-content">
                            <h5 className="card-title mt-3">Author Name</h5>
                            <h2 className="mt-4">Cryptocurrency Mobile App</h2>
                          </div>
                        </div>
                        <div className="card-footer">
                          <a
                            href="template-blog-detail.html"
                            className="read-more btn btn-round btn-glow btn-gradient-blue"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section id="contact" className="contact section-padding">
              <div className="container-fluid">
                <div className="container">
                  <div className="heading text-center">
                    <h6
                      className="sub-title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.2s"
                    >
                      Contact
                    </h6>
                    <h2
                      className="title animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      Contact<strong> Crypto ICO</strong>
                    </h2>
                    <div
                      className="separator animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.3s"
                    >
                      <span className="large" />
                      <span className="medium" />
                      <span className="small" />
                    </div>
                    <p
                      className="content-desc animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.4s"
                    >
                      Have questions? We’re happy to help.
                    </p>
                    <p
                      className="font-medium mt-5 animated"
                      data-animation="fadeInUpShorter"
                      data-animation-delay="0.5s"
                    >
                      Contact us with any questions regarding Crypto ICO.
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-lg-5 col-md-12 mx-auto">
                      <ul className="list-unstyled list-group contact-info mb-3">
                        <li
                          className="pt-1 animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.6s"
                        >
                          <i className="ti-location-pin" />
                          <span>Kelley A. Fleming 96 Woodside USA.</span>
                        </li>
                        <li
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.7s"
                        >
                          <i className="ti-email" />
                          <span>info@yourcompany.com</span>
                        </li>
                        <li
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.8s"
                        >
                          <i className="ti-comment-alt" />
                          <span>Join us on Telegram</span>
                        </li>
                        <li
                          className="animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.9s"
                        >
                          <i className="ti-headphone" />
                          <span>+44 0123 4567</span>
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-7 col-md-12 mx-auto">
                      <form
                        action="#"
                        method="post"
                        acceptCharset="utf-8"
                        className="text-center"
                      >
                        <input
                          type="text"
                          className="form-control animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.8s"
                          name="name"
                          placeholder="Your Name"
                        />
                        <input
                          type="text"
                          className="form-control animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="0.9s"
                          name="mail"
                          placeholder="Your Mail"
                        />
                        <textarea
                          rows={4}
                          className="form-control animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="1.0s"
                          name="message"
                          placeholder="Your Massage"
                          defaultValue={""}
                        />
                        <button
                          type="submit"
                          className="btn btn-lg btn-gradient-blue btn-glow float-right animated"
                          data-animation="fadeInUpShorter"
                          data-animation-delay="1.1s"
                        >
                          Send Message
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div
              className="modal ico-modal fade"
              id="ico-modal"
              tabIndex={-1}
              role="dialog"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body p-0">
                    <div className="embed-responsive embed-responsive-16by9">
                      <iframe className="embed-responsive-item" id="video" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser9"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser9Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-9-lg.jpg"
                          alt="Logan S. Perez"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser9Title">Logan S. Perez</h5>
                        <small className="text-muted mb-0 ">
                          CEO &amp; CFO
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser6"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser6Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-6-lg.jpg"
                          alt="Susan J. Newsom"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser6Title">Susan J. Newsom</h5>
                        <small className="text-muted mb-0 ">
                          Graphic Designer
                        </small>
                        <div className="social-profile">
                          <a href="#" title="Linkedin" className="mr-2">
                            <i className="ti-linkedin" />
                          </a>
                          <a href="#" title="Twitter" className="mr-2">
                            <i className="ti-twitter-alt" />
                          </a>
                          <a href="#" title="Github">
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser2"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser2Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-2-lg.jpg"
                          alt="Mary J. Wardle"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser2Title">Mary J. Wardle</h5>
                        <small className="text-muted mb-0 ">CPO</small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser10"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser10Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-10-lg.jpg"
                          alt="Nicholas M. Sharpe"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser10Title">Nicholas M. Sharpe</h5>
                        <small className="text-muted mb-0 ">
                          UI / UX Designer
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser4"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser4Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-4-lg.jpg"
                          alt="Cecelia T. Carter"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser4Title">Cecelia T. Carter</h5>
                        <small className="text-muted mb-0 ">CTO</small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser13"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser13Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-13-lg.jpg"
                          alt="Terry T. Robinette"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser13Title">Terry T. Robinette</h5>
                        <small className="text-muted mb-0 ">Developer</small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser1"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser1Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-1-lg.jpg"
                          alt="Nadia Sidko"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser1Title">Nadia Sidko</h5>
                        <small className="text-muted mb-0 ">
                          Blockchain Entrepreneur
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser8"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser8Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-8-lg.jpg"
                          alt="Pavel Volek"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser8Title">Pavel Volek</h5>
                        <small className="text-muted mb-0 ">
                          Entrepreneur and Investor
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser3"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser3Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-3-lg.jpg"
                          alt="Alyona Blakytna"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser3Title">Alyona Blakytna</h5>
                        <small className="text-muted mb-0 ">
                          Fin-Tech Entrepreneur
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser11"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser11Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-11-lg.jpg"
                          alt="Martin Solarik"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser11Title">Martin Solarik</h5>
                        <small className="text-muted mb-0 ">
                          Fin-Tech Investor
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser7"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser7Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-7-lg.jpg"
                          alt="Kate Fisenko"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser7Title">Kate Fisenko</h5>
                        <small className="text-muted mb-0 ">
                          Fin-Tech Investor
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal team-modal fade"
              id="teamUser12"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="teamUser12Title"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="modal-body">
                    <div className="row p-4">
                      <div className="col-12 col-md-5">
                        <img
                          className="img-fluid rounded"
                          src="theme-assets/images/user-12-lg.jpg"
                          alt="Michal Krajnansky"
                        />
                      </div>
                      <div className="col-12 col-md-7 mt-sm-3">
                        <h5 id="teamUser12Title">Michal Krajnansky</h5>
                        <small className="text-muted mb-0 ">
                          Blockchain Entrepreneur
                        </small>
                        <div className="social-profile">
                          <a
                            href="#"
                            title="Linkedin"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-linkedin" />
                          </a>
                          <a
                            href="#"
                            title="Twitter"
                            className="font-medium grey-accent2 mr-2"
                          >
                            <i className="ti-twitter-alt" />
                          </a>
                          <a
                            href="#"
                            title="Github"
                            className="font-medium grey-accent2"
                          >
                            <i className="ti-github" />
                          </a>
                        </div>
                        <div className="my-4">
                          <p>
                            Experienced algorithmic crypto trader and a machine
                            learning evangelist.
                          </p>
                          <p>
                            I’m focusing on the logic behind the combination of
                            analysis tools, neural networks and genetic
                            algorithms for optimization. Always wanted to have a
                            trading bot with more features but never had the
                            time to build a solution beyond basic python
                            technical analysis tracker.
                          </p>
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Blockchain</small>
                          {"{"}" "{"}"}
                          <small className="float-right">85%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "85%" }}
                            aria-valuenow={85}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">Python</small>
                          {"{"}" "{"}"}
                          <small className="float-right">90%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "90%" }}
                            aria-valuenow={90}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                        <h6 className="mb-0">
                          <small className="text-uppercase">C++</small>
                          {"{"}" "{"}"}
                          <small className="float-right">75%</small>
                        </h6>
                        <div className="progress box-shadow-1 mb-4">
                          <div
                            className="progress-bar progress-orange"
                            role="progressbar"
                            style={{ width: "75%" }}
                            aria-valuenow={75}
                            aria-valuemin={0}
                            aria-valuemax={100}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default App;
